var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2584 15.4444H6.55469L6.92506 12.1111L10.2584 15.4444Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6468 4.68689L10.3876 14.9461C10.3049 15.0288 10.1958 15.0799 10.0793 15.0905L6.85243 15.3838C6.51958 15.4141 6.25133 15.1155 6.31687 14.7878L6.8966 11.8892C6.91596 11.7924 6.96353 11.7035 7.03334 11.6337L17.3135 1.35355C17.5087 1.15829 17.8253 1.15829 18.0206 1.35355L20.6468 3.97978C20.8421 4.17504 20.8421 4.49162 20.6468 4.68689Z",
    stroke: "white",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14815 4.33325H1V19.5184H16.5556V12.8518",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66602 14.3333L17.2956 4.70362",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLigh);
export default __webpack_public_path__ + "static/media/edit_ligh.29b6555a6ca9a5e8d7d07998a6f125df.svg";
export { ForwardRef as ReactComponent };